import { Box, Card, Grid, IconButton, Typography, Chip, Avatar, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import FechaFunction from '../../function/FechaFunction';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const LogsTicketOld = ({
    item,
    type,
    handleClose
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const navigate = useNavigate();
    
    const isClosed = item && item.cerrado_tk;
    const statusColor = isClosed ? '#6366f1' : '#10b981';
    const statusLabel = isClosed ? 'Cerrado' : 'Abierto';
    const statusIcon = isClosed ? <CheckCircleIcon sx={{ fontSize: 16 }} /> : <PendingIcon sx={{ fontSize: 16 }} />;
    const statusDate = isClosed ? item.cerrado_tk : item.createdAt;
    
    const redirect = ()=>{
        if(handleClose){
            handleClose()
        }
        switch (type) {
            case 'nubicom':
                navigate(`/ticket/${item.id_tk}/nubicom`)
                break;
            case 'strong':
                navigate(`/ticket/${item.id_tk}/strongsystems`)
                break;
            case 'ids':
                navigate(`/ticket/${item.id_tk}/ids`)
                break;
            case 'cvv':
                navigate(`/ticket/${item.id_tk}/ids`)
                break;
            default:
                navigate(`/ticket/${item.id_tk}/cvv`)
                break;
        }
    }
    return (
        <Card 
            onClick={()=> redirect()}
            sx={{
                background: isDarkMode ? '#2d3a52 !important' : '#ffffff !important',
                borderRadius: 2,
                border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e3e7ed',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 4,
                    background: isClosed 
                        ? 'linear-gradient(90deg, #6366f1, #8b5cf6)'
                        : 'linear-gradient(90deg, #10b981, #059669)',
                }
            }}
        >
            <Box p={2.5}>
                <Box display='flex' alignItems='center' gap={2}>
                    {/* ID Badge */}
                    <Box
                        sx={{
                            position: 'relative',
                            minWidth: 70,
                            height: 70
                        }}
                    >
                        <Box
                            sx={{
                                borderRadius: 2,
                                height: '100%',
                                width: '100%',
                                background: `linear-gradient(135deg, ${statusColor}15 0%, ${statusColor}25 100%)`,
                                border: `2px solid ${statusColor}40`,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                transition: 'all 0.3s ease'
                            }}
                        >
                            <ConfirmationNumberIcon sx={{ fontSize: 20, color: statusColor, mb: 0.5 }} />
                            <Typography 
                                sx={{
                                    color: statusColor,
                                    fontWeight: 700,
                                    fontSize: 16
                                }}
                            >
                                #{item.id_tk}
                            </Typography>
                        </Box>
                    </Box>

                    {/* Contenido principal */}
                    <Box flex={1}>
                        {/* Título */}
                        <Typography 
                            sx={{
                                color: isDarkMode ? '#e0e0e0' : '#2d3748',
                                fontWeight: 600,
                                fontSize: 16,
                                mb: 1,
                                lineHeight: 1.3,
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden'
                            }}
                        >
                            {item.titulo_tk}
                        </Typography>

                        {/* Footer con estado y fecha */}
                        <Box display='flex' alignItems='center' justifyContent='space-between' flexWrap='wrap' gap={1}>
                            {/* Estado */}
                            <Chip 
                                icon={statusIcon}
                                label={statusLabel}
                                size="small"
                                sx={{
                                    height: 24,
                                    fontSize: 11,
                                    fontWeight: 600,
                                    backgroundColor: `${statusColor}15`,
                                    color: statusColor,
                                    border: `1px solid ${statusColor}40`,
                                    '& .MuiChip-icon': {
                                        color: statusColor,
                                        ml: 1
                                    }
                                }}
                            />

                            {/* Fecha */}
                            <Box display='flex' alignItems='center' gap={0.5}>
                                <AccessTimeIcon sx={{ fontSize: 14, color: isDarkMode ? '#b0bec5' : '#9ca3af' }} />
                                <Typography 
                                    sx={{
                                        color: isDarkMode ? '#b0bec5' : '#9ca3af',
                                        fontSize: 11,
                                        fontWeight: 500,
                                        letterSpacing: 0.3
                                    }}
                                >
                                    {FechaFunction.format(new Date(statusDate), 'dd/MM/yyyy HH:mm')}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Arrow icon */}
                    <Box 
                        className="arrow-icon"
                        sx={{
                            opacity: 0.5,
                            transition: 'all 0.3s ease',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <ArrowForwardIcon sx={{ fontSize: 24, color: isDarkMode ? '#b0bec5' : '#9ca3af' }} />
                    </Box>
                </Box>
            </Box>
        </Card>
    );
}

LogsTicketOld.defaultProps = {
    canShowMore:false,
    buttons:null,
};

export default LogsTicketOld;
